// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading svg polyline {
    fill: none;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  
  .loading svg polyline#back {
    fill: none;
    stroke: #ff4d5033;
  }
  
  .loading svg polyline#front {
    fill: none;
    stroke: #ff4d4f;
    stroke-dasharray: 48, 144;
    stroke-dashoffset: 192;
    animation: dash_682 1.4s linear infinite;
  }
  
  @keyframes dash_682 {
    72.5% {
      opacity: 0;
    }
  
    to {
      stroke-dashoffset: 0;
    }
  }
  
  .loading{
    display: flex;
justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/LoadAlerts.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,aAAa;AACjB,uBAAuB;EACrB","sourcesContent":[".loading svg polyline {\r\n    fill: none;\r\n    stroke-width: 3;\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n  }\r\n  \r\n  .loading svg polyline#back {\r\n    fill: none;\r\n    stroke: #ff4d5033;\r\n  }\r\n  \r\n  .loading svg polyline#front {\r\n    fill: none;\r\n    stroke: #ff4d4f;\r\n    stroke-dasharray: 48, 144;\r\n    stroke-dashoffset: 192;\r\n    animation: dash_682 1.4s linear infinite;\r\n  }\r\n  \r\n  @keyframes dash_682 {\r\n    72.5% {\r\n      opacity: 0;\r\n    }\r\n  \r\n    to {\r\n      stroke-dashoffset: 0;\r\n    }\r\n  }\r\n  \r\n  .loading{\r\n    display: flex;\r\njustify-content: center;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
